module.exports = __webpack_public_path__ + "img/background015.a07a438a.jpg";